module.exports = __webpack_public_path__ + "static/img/40014 (3).99b444e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40014 (3).webp
// module id = sTHY
// module chunks = 14